import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'

import store from '@/store'
import { mixin } from '@/mixins/helper'
import { api, api_lp } from '@/services/config'
import axios from 'axios'

Vue.mixin({
  methods: {
    async $autoComplete(search) {
      const url = `${api}/api/v1/vendor-level-1?page=1&limit=100&search=${search}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {
        return []
      }
    },
    async $vendorName(search) {
      const url = `${api}/api/v1/vendor-level-1?page=1&limit=500&search=${search}`
      store.commit('SET_GLOBAL_LOADING', true)
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        store.commit('SET_GLOBAL_LOADING', false)
        return data.data
      } catch (error) {
        store.commit('SET_GLOBAL_LOADING', false)
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $companyCode(company_name) {
      const url = `${api}/api/v1/company-code-${company_name}?page=1&limit=20000`

      store.commit('SET_GLOBAL_LOADING', true)
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        store.commit('SET_GLOBAL_LOADING', false)
        return data.data
      } catch (error) {
        store.commit('SET_GLOBAL_LOADING', false)
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async $gemsCompanies() {
      const url = `${api}/api/v1/user/hse-company-group`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async $getKbli() {
      const url = `${api}/api/v1/kbli-sub?page=1&limit=2000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getIujp() {
      const url = `${api}/api/v1/iujp?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getIujpNonInti() {
      store.commit('SET_GLOBAL_LOADING', true)
      const url = `${api}/api/v1/perizinan-non-inti?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        store.commit('SET_GLOBAL_LOADING', false)
        return data.data
      } catch (error) {
        store.commit('SET_GLOBAL_LOADING', false)
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getGoldenRules() {
      const url = `${api}/api/v1/golden-rules?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getSbujk() {
      const url = `${api}/api/v1/sbujk?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getIujptl() {
      const url = `${api}/api/v1/iujptl?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getInubbm() {
      const url = `${api}/api/v1/inu-bbm?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getSiupal() {
      const url = `${api}/api/v1/siupal?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {}
    },
    async $getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {}
    },
    async $getCity(id) {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {}
    },
    async $getDistric(id) {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {}
    },
    async $getVillage(id) {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        return data.data
      } catch (error) {}
    },
    async $getLegal() {
      const url = `${api}/api/v1/legal-document?page=1&limit=2000&is_active=1`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })
        return data.data
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async $getBidangUsahaGems() {
      try {
        store.commit('SET_GLOBAL_LOADING', true)
        const url = `${api_lp}/api/v1/vendor/kbug`
        const { data } = await axios({
          method: 'get',
          url,
          auth: {
            username: process.env.VUE_APP_SAP_USER,
            password: process.env.VUE_APP_SAP_PASS,
          },
        })
        store.commit('SET_GLOBAL_LOADING', false)
        return data.data
      } catch (error) {
        store.commit('SET_GLOBAL_LOADING', false)
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
})
